import React, {memo} from 'react'
import _ from 'lodash'
import {getAmountString} from '../../util'
import {Header, Icon, Table} from 'semantic-ui-react'
import {withPropsPresent} from '../../hoc'
import SelectPlan from './select-plan'

const _Invoices = (
  {
    invoices
  }
) => {
  return (
    <>
      <Header as='h3'>Invoices</Header>
      <Table celled columns='16' data-testid='invoices'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Amount</Table.HeaderCell>
            <Table.HeaderCell>Invoice #</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Created</Table.HeaderCell>
            <Table.HeaderCell>Download</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            invoices.map(i => {
              const totalString = getAmountString(i.total - (i.pre_payment_credit_notes_amount || 0) - (i.post_payment_credit_notes_amount || 0))
              return (
                <Table.Row key={i.id}>
                  <Table.Cell data-test='invoice-amount'>{totalString}</Table.Cell>
                  <Table.Cell data-test='invoice-number'>{i.number}</Table.Cell>
                  <Table.Cell data-test='invoice-status'>{_.startCase(i.status)}</Table.Cell>
                  <Table.Cell data-test='invoice-created'>{new Date(i.created * 1000).toDateString()}</Table.Cell>
                  <Table.Cell data-test='invoice-download'><a target='_blank' href={i.invoice_pdf}><Icon name='download'/></a></Table.Cell>
                </Table.Row>
              )
            })
          }
        </Table.Body>
      </Table>
    </>
  )
}

let Invoices = (props) => {
  props = {...props, invoices: props.subscription.invoices}
  return (<_Invoices {...props}/>)
}

Invoices = withPropsPresent(Invoices, ['subscription'])
Invoices = memo(Invoices)

export {Invoices, _Invoices}

export default Invoices